/* istanbul ignore file */

/* tslint:disable */

/* eslint-disable */
export var BusinessViewBrokerWorkflowStage;

(function (BusinessViewBrokerWorkflowStage) {
  BusinessViewBrokerWorkflowStage["OUTREACHED"] = "outreached";
  BusinessViewBrokerWorkflowStage["DEMO_BOOKED"] = "demo_booked";
  BusinessViewBrokerWorkflowStage["BROKER_MEMBERS"] = "broker_members";
  BusinessViewBrokerWorkflowStage["IN_PERSON_TRAINING"] = "in_person_training";
  BusinessViewBrokerWorkflowStage["ONLINE_TRAINING"] = "online_training";
  BusinessViewBrokerWorkflowStage["COMPLETED"] = "completed";
})(BusinessViewBrokerWorkflowStage || (BusinessViewBrokerWorkflowStage = {}));